import React, { useState, useMemo } from "react";
import DeviceTable from "./DeviceTable";
import "./DeviceSettings.css";
import { useTimeseriesSysconfig } from "../../simulations/hooks/useTimeseriesSysconfig";
import { useDevices } from "../hooks/useDevices";
import { processDevicesForTable } from "../adapters/deviceTableAdapter";

const SimulationDevicesPage = () => {
  const [activeTab, setActiveTab] = useState("All");

  const {
    storageAccount,
    microgridName,
    datasetName,
    loading: paramsLoading,
  } = useTimeseriesSysconfig();

  const {
    sysconfig,
    loading: devicesLoading,
    error: devicesError,
  } = useDevices({ storageAccount, microgridName, datasetName });

  const loading = paramsLoading || devicesLoading;
  const error = devicesError
    ? "Something went wrong while fetching device data."
    : "";

  const {
    storage: storageDevices,
    consumption: consumptionDevices,
    production: productionDevices,
  } = useMemo(() => processDevicesForTable(sysconfig), [sysconfig]);

  const allDevices = useMemo(() => {
    const combined = [
      ...productionDevices.map((d) => ({ ...d, deviceCategory: "Production" })),
      ...consumptionDevices.map((d) => ({ ...d, deviceCategory: "Consumption" })),
      ...storageDevices.map((d) => ({ ...d, deviceCategory: "Storage" })),
    ];
    return combined.sort((a, b) =>
      (a.device_name || "").localeCompare(b.device_name || ""),
    );
  }, [productionDevices, consumptionDevices, storageDevices]);

  const filteredDevices = useMemo(() => {
    if (activeTab === "All") return allDevices;
    return allDevices.filter((d) => d.deviceCategory === activeTab);
  }, [activeTab, allDevices]);

  const deviceTabs = [
    { key: "All", label: "All", count: allDevices.length },
    { key: "Production", label: "Production", count: productionDevices.length },
    { key: "Consumption", label: "Consumption", count: consumptionDevices.length },
    { key: "Storage", label: "Storage", count: storageDevices.length },
  ];

  const subHeader = microgridName
    ? `${microgridName} \u00b7 ${allDevices.length} ${allDevices.length === 1 ? "device" : "devices"}`
    : "";

  return (
    <div className="main devices">
      <div className="container-fluid">
        {loading ? (
          <div className="spinner-container">
            <div className="spinner" />
          </div>
        ) : error ? (
          <div className="alert alert-danger mt-4">{error}</div>
        ) : (
          <DeviceTable
            devices={filteredDevices}
            tabs={deviceTabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            subHeader={subHeader}
          />
        )}
      </div>
    </div>
  );
};

export default SimulationDevicesPage;
